import { render, staticRenderFns } from "./PopbillCertRegistration.vue?vue&type=template&id=65aad3e5&scoped=true&lang=pug&"
import script from "./PopbillCertRegistration.vue?vue&type=script&lang=ts&"
export * from "./PopbillCertRegistration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65aad3e5",
  null
  
)

export default component.exports